require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./offres-culturelles-1-10-2.json") })
        }
      }, "path---offres-culturelles-1-10-2");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---offres-culturelles-1-10-2!./.cache/json/offres-culturelles-1-10-2.json
// module id = 510
// module chunks = 231608221292675